import { useState } from "react";
import IndlagtePlotMini from "./IndlagtePlotMini";

function Indlagte({ data }) {
	const indlagteSenest = data.sort((a, b) => b.date - a.date)[0]

	const [type, setType] = useState("actual");

	const numbers = {
		indlagte: { actual: indlagteSenest.currentHospitalized.toFixed(), percent: indlagteSenest.currentHospitalized.toFixed() },
		intensiv: { actual: indlagteSenest.currentIntensive.toFixed(), percent: `${(indlagteSenest.currentIntensive / indlagteSenest.currentHospitalized * 100).toFixed()}${'\u202F'}%` },
		respirator: { actual: indlagteSenest.currentRespirator.toFixed(), percent: `${(indlagteSenest.currentRespirator / indlagteSenest.currentHospitalized * 100).toFixed()}${'\u202F'}%` },
	}

	const togglePercent = () => setType(type === "actual" ? "percent" : "actual");

	return (
		<div>
			<h1>Indlagte nu</h1>
			<div className="numberCircleMedium" style={{ backgroundColor: "steelblue" }}>
				<span>{numbers.indlagte[type]}</span>
				<div className="circleDateMedium">
					<small>{indlagteSenest.date.toISOString().substring(0, 10)}</small>
				</div>
			</div>
			<div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }} onClick={togglePercent}>
				<div className="numberCircleSmall" style={{ backgroundColor: "orange" }}>
					<span>{numbers.intensiv[type]}</span>
					<div className="circleDateSmall">
						<small>Intensive</small>
					</div>
				</div>
				<div className="numberCircleSmall" style={{ backgroundColor: "red" }} onClick={togglePercent}>
					<span>{numbers.respirator[type]}</span>
					<div className="circleDateSmall">
						<small>Respirator</small>
					</div>
				</div>
			</div>
			<IndlagtePlotMini data={data} type={type} />
		</div>
	)
}

export default Indlagte